var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.terms.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.terms.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }